"use client";
import placement from "../../assets/course-details/placement.png";
import placementJourney from "../../assets/course-details/placementJourney.svg";
import SectionHeading from "../shared/SectionHeading";

const Placement = ({ data }) => {
  if (!data.section[5].isActive) {
    return <div></div>;
  }

  return (
    <div
      className="mt-12 mx-auto py-12"
      style={{
        background:
          "linear-gradient(90deg, rgba(255, 153, 0, 0.05) 0%, rgba(4, 35, 107, 0.05) 100%)",
      }}
    >
      <h1 className="text-center text-primary-color text-2xl lg:text-3xl font-bold mb-2">
        Placement <span className="text-secondary-color">Overview</span>
      </h1>
      <div className="mx-auto max-w-[1500px] px-4">
        {/* Specialization-Wise Placements Section */}
        <div className="mt-8 flex flex-col lg:flex-row items-center lg:justify-center gap-4 lg:gap-8">
          <div className="flex-1 flex justify-end items-center min-w-[160px]">
            <img
              src={placement}
              alt="Specialization Placement"
              className="w-[180px] sm:w-[240px] md:w-[280px] lg:w-[260px] xl:w-[300px] rounded-xl p-2 object-contain"
            />
          </div>
          <div className="flex-1 flex items-center justify-start mt-4 lg:mt-0 lg:ml-10">
            <div className="text-center lg:text-left px-2 md:px-4 py-3 max-w-lg">
              <h2 className="text-secondary-color text-xl lg:text-2xl font-semibold mb-1">
                Specialization
                <span className="text-primary-color">-Wise Placements</span>
              </h2>
              <p className="mt-1 text-base md:text-lg lg:text-[1.1rem] max-w-[600px] mx-auto lg:mx-0">
                {data.section[5].body.content1}
              </p>
            </div>
          </div>
        </div>

        {/* Competitive Packages Section */}
        <div className="mt-6">
          <h2 className="text-primary-color text-xl lg:text-2xl font-bold tracking-tight mb-3 text-center">
            Competitive <span className="text-secondary-color">Packages</span>
          </h2>

          <div className="flex justify-center">
            <div className="flex flex-col md:flex-row items-stretch gap-3">
              {data.section[5].body.list1.slice(0, 3).map((item, index) => (
                <div
                  key={index}
                  className="bg-white/90 border-l-4 border-[#1e3a8a] rounded-xl shadow px-4 py-4 w-full md:w-[220px]"
                >
                  <span className="text-[13px] text-[#262626] leading-snug break-words">
                    {item.text}
                  </span>
                </div>
              ))}
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default Placement;
